import React from 'react';
import { T, CARD, Field, DarkInput, SaveBtn } from './ContentShared';

const ManifesteEditor = ({ data, setData, onSave, saving }) => {
  if (!data) return null;
  const set = (key, val) => setData({ ...data, [key]: val });

  return (
    <div className="space-y-6" data-testid="manifeste-editor">
      <div className="rounded-2xl p-6 space-y-5" style={CARD}>
        <h2 className="text-base font-semibold" style={{ fontFamily: "'Playfair Display', serif", color: T.textPrimary }}>Section Manifeste</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Label (FR)"><DarkInput value={data.label_fr} onChange={e => set('label_fr', e.target.value)} testId="manifeste-label-fr" /></Field>
          <Field label="Label (EN)"><DarkInput value={data.label_en} onChange={e => set('label_en', e.target.value)} testId="manifeste-label-en" /></Field>
        </div>
        <Field label="Citation (FR)"><DarkInput value={data.quote_fr} onChange={e => set('quote_fr', e.target.value)} rows={3} testId="manifeste-quote-fr" /></Field>
        <Field label="Citation (EN)"><DarkInput value={data.quote_en} onChange={e => set('quote_en', e.target.value)} rows={3} testId="manifeste-quote-en" /></Field>
        <Field label="Signature"><DarkInput value={data.signature} onChange={e => set('signature', e.target.value)} testId="manifeste-signature" /></Field>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Tagline (FR)"><DarkInput value={data.tagline_fr} onChange={e => set('tagline_fr', e.target.value)} testId="manifeste-tagline-fr" /></Field>
          <Field label="Tagline (EN)"><DarkInput value={data.tagline_en} onChange={e => set('tagline_en', e.target.value)} testId="manifeste-tagline-en" /></Field>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="CTA (FR)"><DarkInput value={data.cta_text_fr} onChange={e => set('cta_text_fr', e.target.value)} /></Field>
          <Field label="CTA (EN)"><DarkInput value={data.cta_text_en} onChange={e => set('cta_text_en', e.target.value)} /></Field>
        </div>
        <Field label="URL CTA"><DarkInput value={data.cta_url} onChange={e => set('cta_url', e.target.value)} /></Field>
      </div>
      <SaveBtn onClick={() => onSave('manifeste', data)} saving={saving} testId="save-manifeste-btn" />
    </div>
  );
};

export default ManifesteEditor;
